export const passwordRegex = /(?=.*?[A-Z])/;
export const validateIntegerNumbers = /^\d*$/;
export const validateDigitsAndDot = /^[.0-9]*$/;
export const stringRegex = /\D/g;
export const validatePosNegNumbers = /^-?\d*[.]?\d{0,2}$/;
export const validatePosNegIntegerNumbers = /^-?\d*$/;
export const excludeStringSymbols = /[^.0-9]/g;
export const excludeExpenseCompSymbols = /[^0-9.-]/g;
export const firstStringChar = /^\w/;
export const numberRangeRegExp =
  /^(100(?:\.00?)?|\d{1,2}(?:\.\d{0,2})?|\d{0,2})%?$/;
export const decimalNumberRangeRegExp =
  /^(100(?:\.0{0,2})?|\d{1,2}(?:\.\d{0,2})?|\d{0,2})%?$/;
